/* ModalCoverPhoto.js */

import React, { useCallback, useState } from 'react';
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap';
import RemixCoverPhoto from '../remix/RemixCoverPhoto';
import Strings from '../../translations/Translations';

export default function ModalCoverPhoto({ photo, setPhoto }) {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen(!open), [open, setOpen]);

  return (
    <>
      <Button className='pb-btn-1' onClick={toggle}>{Strings('upload_cover_photo')}</Button>

      <Modal isOpen={open} toggle={toggle} size='lg'>
        <ModalHeader toggle={toggle}>
          {Strings('upload_cover_photo')}
        </ModalHeader>
        <ModalBody>
          <RemixCoverPhoto photo={photo} setPhoto={setPhoto} />
        </ModalBody>
      </Modal>
    </>
  );
}
